import React, { ReactNode } from "react";
import { RFX_STATUS } from "utils/constants";

type RfxStatusCompProps = {
	status: string;
	isRoundedFull?: boolean;
	isApproved?: boolean;
};

export const RFQStatusComp: React.FC<RfxStatusCompProps> = ({
	status,
	isRoundedFull = true,
	isApproved = null,
}) => {
	status = status?.replace(/ /g, "")?.toUpperCase();

	const AWAITING_APPROVAL = "AWAITING APPROVAL";
	const CLOSED = "CLOSED";
	const EVALUATION = "EVALUATION";
	const OPEN = "OPEN";

	const getRfxStatus = (status) => {
		switch (status) {
			case RFX_STATUS.DRAFT:
				return AWAITING_APPROVAL;
			case RFX_STATUS.AWARDED:
			case RFX_STATUS.ARCHIVED:
				return CLOSED;
			case RFX_STATUS.ACTIVE:
				return OPEN;
			default:
				return status;
		}
	};

	const rfqStatus = [
		{
			status: "Closed",
			color: "#B42318",
			background: "#FEF3F2",
			colorBorder: "#FECDCA",
		},
		{
			status: "Open",
			color: "#00976B",
			background: "#D5F9F3",
			colorBorder: "#0FE3C7",
		},
		{
			status: "Evaluation",
			color: "#5925DC",
			background: "#F4F3FF",
			colorBorder: "#D9D6FE",
		},
		{
			status: "Awaiting Approval",
			color: "#5925DC",
			background: "#F4F3FF",
			colorBorder: "#D9D6FE",
		},
		{
			status: "Approved",
			color: "#0088cc",
			background: "#F4F3FF",
			colorBorder: "#D9D6FE",
		},
	];

	const generateStatus = (statusOption: number): ReactNode => {
		return (
			<div
				className={`flex items-center justify-center text-center font-roboto text-[14px] font-medium ${isRoundedFull ? "rounded-full" : "rounded-md"} p-3 shadow-sm`}
				style={{
					width: "fit-content",
					color: rfqStatus[statusOption].color,
					background: rfqStatus[statusOption].background,
					border: `solid 1px ${rfqStatus[statusOption].colorBorder}`,
					height: "24px",
				}}
			>
				{rfqStatus[statusOption].status}
			</div>
		);
	};

	switch (getRfxStatus(status)) {
		case CLOSED:
			return generateStatus(0);
		case OPEN:
			return generateStatus(1);
		case EVALUATION:
			return generateStatus(2);
		case AWAITING_APPROVAL:
			return generateStatus(isApproved ? 4 : 3);
		default:
			return null;
	}
};
